module.exports = __webpack_public_path__ + "img/logo_balkandetox.0af3eef5.png";